import type { ShiftFormManagerDashboard, ShiftFormManagerDashboardFilters } from "../../../shared/shift-production-form/contracts";
import type { AnalysisMetric } from "./analysis-columns";

type Row = ShiftFormManagerDashboard["rows"][number];
export function missingMeasurement(row: Row, metric: AnalysisMetric) {
  if (metric === "DOWNTIME") return row.downtimeMinutes === null;
  if (metric === "OUTPUT") return !row.actualOutputs.some(item => item.unit === "koli");
  return !row.wasteEntries.some(item => item.key === "SCRAP" && item.unit === "kg");
}
export const missingMeasurementLabel = (metric: AnalysisMetric) => metric === "OUTPUT" ? "Çıkan ürün / koli" : metric === "DOWNTIME" ? "Duruş başlangıç veya bitiş zamanı" : "Iskarta / kg";

/** Read all authorized pages. Reject moving result sets instead of showing an incomplete list as complete. */
export async function readMissingMeasurements(filters: ShiftFormManagerDashboardFilters, metric: AnalysisMetric, read: (scope: ShiftFormManagerDashboardFilters) => Promise<ShiftFormManagerDashboard>, isActive: () => boolean = () => true) {
  const rows: Row[] = [];
  const ids = new Set<string>();
  let expected: number | null = null;
  for (let offset = 0; ; ) {
    if (!isActive()) return null;
    const page = await read({ ...filters, limit: 500, offset });
    if (!isActive()) return null;
    expected ??= page.coverage.totalMatchingForms;
    if (page.coverage.totalMatchingForms !== expected || page.rows.some(row => ids.has(row.id))) throw new Error("Kayıtlar inceleme sırasında değişti. Listeyi yeniden yükleyin.");
    page.rows.forEach(row => ids.add(row.id));
    rows.push(...page.rows.filter(row => missingMeasurement(row, metric)));
    offset += page.rows.length;
    if (!page.coverage.truncated) {
      if (offset !== expected) throw new Error("Kaynak kayıtların tamamı alınamadı. Listeyi yeniden yükleyin.");
      return rows;
    }
    if (!page.rows.length || offset >= expected) throw new Error("Kaynak kayıtların tamamı alınamadı. Listeyi yeniden yükleyin.");
  }
}
